import i18n from '../i18n';
// Only authored system-copy keys belong here. Never pass names or user content as keys.
export const presentationText = (key, params) => i18n.t(key, params);
